import Footer from "../layout/Footer";
import HorizontalNav from "../layout/HorizontalNav";
import { useLocation, Outlet } from "react-router-dom";
import { Suspense } from "react";
import useUser from "../features/dashboard/hooks/useUser";
import Loader from "../core/components/Loader";
import { ROUTING_PATH } from "../core/config/Constant";

const Layout = (props) => {
  const location = useLocation();
  
  // Warm up the user profile query globally
  useUser();

  // Define base routes where Footer should be hidden
  const noFooterRoutes = [
    ROUTING_PATH.ADD_NEW_PROPERTY,
    ROUTING_PATH.ADD_NEW_PROJECT,
    ROUTING_PATH.EDIT_PROPERTY,
    ROUTING_PATH.EDIT_PROJECT
  ];

  // Check if the current path starts with any route in noFooterRoutes
  const hideFooter = noFooterRoutes.some(route => location.pathname.startsWith(route));

  return (
    <>
      <HorizontalNav />
      <Suspense fallback={<Loader />}>
        <Outlet />
      </Suspense>
      {/* Conditionally render Footer */}
      {!hideFooter && <Footer />}
    </>
  );
};

export default Layout;
